import { jsx as n, Fragment as u, jsxs as m } from "react/jsx-runtime";
import { useState as p } from "react";
import { GradientButton as c } from "../gradient-button/index.js";
import { MenuItem as C } from "../menu-item/index.js";
import e from "./styles.module.less.js";
import h from "./spark.svg.js";
import d from "./message.svg.js";
import { getRoute as l, RouteType as i } from "../../../../utils/get-route.js";
import b from "../chevron-down.svg.js";
import { MobileMenuDropdown as f } from "../mobile-menu-dropdown/index.js";
const R = (o) => {
  const { getTranslation: a, isScrolledHeader: t, isLawyerSupported: r } = o;
  return r ? /* @__PURE__ */ n(M, { ...o }) : /* @__PURE__ */ n(
    c,
    {
      label: a("pages.chat-now"),
      path: "/chat?newCase=true",
      isScrolledHeader: t
    }
  );
}, M = (o) => {
  const { getTranslation: a, isScrolledHeader: t } = o, [r, g] = p(!1);
  return /* @__PURE__ */ n(
    C,
    {
      label: a("pages.chat"),
      chevronStyle: "rotate",
      hasShrunk: t,
      classNames: {
        wrapper: e.buttonWrapper,
        childContainer: `${e.hoverMenu} ${t ? e.scrolledHeader : ""} ${r ? e.forceOpen : ""}`,
        // labelTitle: styles.chatLabelTitle,
        // linkContainer: isScrolledHeader
        //   ? `${styles.buttonLinkContainer} ${styles.isScrolled}`
        //   : styles.buttonLinkContainer,
        chevronIcon: e.chatChevronIcon,
        gradientButton: e.gradientButton
      },
      onClick: () => g(!r),
      customHover: !0,
      useGradient: !0,
      children: /* @__PURE__ */ n(u, { children: [
        {
          path: l(i.NEW_CHAT),
          title: a("pages.ask-a-question"),
          icon: /* @__PURE__ */ n(h, { className: e.menuIcon })
        },
        {
          path: l(i.LAWYER_REQUEST_CHAT),
          title: a("pages.request-a-lawyer"),
          icon: /* @__PURE__ */ n(d, { className: e.menuIcon })
        }
      ].map((s) => /* @__PURE__ */ m("a", { href: s.path, className: e.menuItem, children: [
        /* @__PURE__ */ n("span", { className: `${e.menuItemText}`, children: s.title }),
        s.icon
      ] }, s.title)) })
    }
  );
}, q = (o) => {
  const { getTranslation: a, isLawyerSupported: t } = o;
  return t ? /* @__PURE__ */ n(S, { ...o }) : /* @__PURE__ */ n(
    c,
    {
      label: a("pages.chat"),
      path: "/chat?newCase=true",
      className: e.mobileMenuGradientButton
    }
  );
}, S = (o) => {
  const { getTranslation: a } = o, [t, r] = p(!1);
  return /* @__PURE__ */ n(
    f,
    {
      toggleOpen: () => r(!t),
      isOpen: t,
      items: [
        {
          title: a("pages.ask-a-question"),
          link: l(i.NEW_CHAT),
          icon: h
        },
        {
          title: a("pages.request-a-lawyer"),
          link: l(i.LAWYER_REQUEST_CHAT),
          icon: d
        }
      ],
      children: /* @__PURE__ */ n(
        c,
        {
          label: /* @__PURE__ */ m(u, { children: [
            a("pages.chat"),
            /* @__PURE__ */ n(
              b,
              {
                className: `${e.buttonChevronIcon} ${t ? e.rotated : ""}`
              }
            )
          ] }),
          className: e.mobileMenuGradientButton,
          labelClassName: e.mobileMenuGradientButtonLabel,
          onClick: () => r(!t),
          isOpen: t
        }
      )
    }
  );
};
export {
  R as MenuChatButtonDesktop,
  q as MenuChatButtonMobile
};
